import React, {useReducer} from "react";
import {initialState, reducer} from "@/components/features/store/Reducer";
import LoadingContext from "@/components/features/store/LoadingContext";
export const LoadingContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <LoadingContext.Provider value={[state, dispatch]}>
            {children}
        </LoadingContext.Provider>
    );
};